import { IRegras } from '../../interface';
import { ColumnsType } from 'antd/lib/table';
import { useTableScroll } from '../../hooks/useTableScroll';
import { useGrupoContext } from '../../context/GroupContext';
import { useEffect, useRef } from 'react';
import { useColumnDateTimeSearch } from '../../../../hooks/FilterTable/date';
import { DeleteOutlined, ProfileOutlined } from '@ant-design/icons';
import { useGetColumnSearchPropsTypeString } from '../../../../hooks/FilterTable/objString';
import { ScrollToBottomButton, ScrollToTopButton } from '../../../../components/ScrollButtunsTable';
import { Table, Button, Tooltip, Popconfirm, Typography } from 'antd';

interface ITabelaGrupoProps {
    regraHook: any;
    theme: string;
}

const { Text } = Typography;

export const TabelaRegra = ({ regraHook, theme }: ITabelaGrupoProps) => {
    const {
        regras,
        loading,
        getRegras,
        deleteRegra,
    } = regraHook;

    const {
        abrirModalGrupo
    } = useGrupoContext();

    const {
        tableRef,
        scrollToTable
    } = useTableScroll();

    const refContagemDoFiltro = useRef<Array<any>>([]);

    useEffect(() => {
        getRegras();
    }, [getRegras]);

    const columnsGrupos: ColumnsType<IRegras> = [
        {
            title: "Ano",
            dataIndex: "ano",
            key: "ano",
            ellipsis: true,
            ...useGetColumnSearchPropsTypeString('ano')
        },
        {
            title: "Atualizada em",
            dataIndex: "atualizado_em",
            key: "atualizado_em",
            ...useColumnDateTimeSearch('atualizado_em'),
        },
        {
            title: "Ações",
            render: (record: IRegras) => {
                return (
                    <>
                        <div className="divAcao">
                            <Tooltip
                                title="Abrir regra"
                                color="blue"
                            >
                                <Button
                                    type="primary"
                                    icon={< ProfileOutlined />}
                                    onClick={() => abrirModalGrupo('regras', record)} />
                            </Tooltip>
                            <Popconfirm
                                title="Deseja excluir?"
                                onConfirm={() => deleteRegra(record.ano)}
                                onCancel={() => { }}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Button
                                    type="primary"
                                    danger
                                    icon={< DeleteOutlined />}
                                />
                            </Popconfirm>
                        </div>
                    </>
                )
            },
        },
    ];

    return (
        <>
            <div ref={tableRef}>
                <Table
                    rowKey="id"
                    dataSource={regras}
                    columns={columnsGrupos}
                    loading={loading}
                    size="small"
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: true,
                        defaultPageSize: 50,
                        position: ['bottomRight'],
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    title={(registros) => {
                        return (
                            <div
                                style={{
                                    backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                    padding: 10,
                                    marginBottom: -8,
                                    margin: -8,
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div
                                    style={{
                                        gap: 5,
                                        display: 'flex'
                                    }}
                                >
                                    <Button
                                        type="primary"
                                        className="btn_success_vlhbegoawrgbvr"
                                        onClick={() => abrirModalGrupo('regras')}
                                    >
                                        Nova Regra
                                    </Button>
                                </div>
                                <ScrollToBottomButton
                                    registros={registros}
                                    onClick={() => scrollToTable('bottom')}
                                />
                                <Text>
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        regras.length :
                                        refContagemDoFiltro.current.length} em um total de ${regras.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    footer={(registros) => {
                        return (
                            <div style={{ textAlign: 'end' }}>
                                <ScrollToTopButton
                                    registros={registros}
                                    onClick={() => scrollToTable('top')}
                                />
                                <Text>
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        regras.length :
                                        refContagemDoFiltro.current.length} em um total de ${regras.length} `}
                                </Text>
                            </div>
                        )
                    }}
                />
            </div>
        </>
    );
};
